export const environment = {
  production: false,
  environment: 'development',
  apiUrl: 'https://ditrack.ditech.es',
  enableLogging: true,
  version: '1.0.0-dev',
  devLogin: false,
  microsoftGraph: {
    clientId: '1dc9d80d-931c-457e-a69c-108b16779924',
    tenantId: '04fce6d2-a139-4217-99bd-ce0bc3c1e6af',
    redirectUri: 'https://ditrack.ditech.es/auth/callback',
    scopes: ['Calendars.Read', 'User.Read', 'offline_access'],
  },
};